// The MIT License (MIT)
//
// Copyright (c) 2016-2021 Camptocamp SA
//
// Permission is hereby granted, free of charge, to any person obtaining a copy of
// this software and associated documentation files (the "Software"), to deal in
// the Software without restriction, including without limitation the rights to
// use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of
// the Software, and to permit persons to whom the Software is furnished to do so,
// subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
// FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
// COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
// IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
// CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

/**
 * Application entry point.
 *
 * This file includes `import`'s for all the components/directives used
 * by the HTML page and the controller to provide the configuration.
 */

import './sass/desktop.scss';
import './sass/vars_desktop.scss';

import angular from 'angular';
import {isEventUsingCtrlKey} from 'ngeo/utils';
import gmfControllersAbstractDesktopController, {
  AbstractDesktopController,
} from 'gmf/controllers/AbstractDesktopController';
import cartobroyeBase from '../cartobroyemodule';

/**
 * @private
 */
class Controller extends AbstractDesktopController {

    constructor($scope, $injector) {

    super($scope, $injector),

    /**
     * @type {boolean}
     */
    this.options.showInfobar = true;
	this.queryGrid = false; //activate the grid info windows in the footer (20260304/rba)
    
    this.openAsitWithBbox = function () {
        const view = this.map.getView();
        const extent = view.calculateExtent(this.map.getSize());
        const provider = ''; //$scope.fournisseur;
        let x = 0;
        const len = extent.length;
        while (x < len) {
            extent[x] = extent[x].toFixed(0);
            x++;
        }
        if (provider != '') {
            window.open('https://viageo.ch/api/shop-select/bbox/' + extent.join('/') + '?provider=' + provider);
        } else {
            window.open('https://viageo.ch/api/shop-select/bbox/' + extent.join('/'));
        }
    };
    }
    
  /**
   * @param {JQuery.Event} event keydown event.
   */
  onKeydown(event) {
    if (event && isEventUsingCtrlKey(event) && event.key === 'p') {
      this.printPanelActive = true;
      event.preventDefault();
    }
  };
  
}

/**
 * @hidden
 */
const cartobroyeModule = angular.module('Appdesktop', [cartobroyeBase.name, gmfControllersAbstractDesktopController.name]);

cartobroyeModule.value('gmfContextualdatacontentTemplateUrl', 'gmf/contextualdata');
cartobroyeModule.run(
  /**
   * @ngInject
   * @param {angular.ITemplateCacheService} $templateCache
   */
  ($templateCache) => {
    // @ts-ignore: webpack
    $templateCache.put('gmf/contextualdata', require('./contextualdata.html'));
  }
);

cartobroyeModule.controller('DesktopController', Controller);

export default cartobroyeModule;
